import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { infoCircle } from "@tql/ui-components-react/untitled/icons";

import * as styles from "./special-instructions.module.css";

type BolNotationsProps = {
	readonly bolNotations?: string;
};

export const BolNotations = ({ bolNotations }: BolNotationsProps) => {
	const notations = bolNotations?.trim();

	if (!notations) {
		return null;
	}

	return (
		<div className={styles.bolNotations} data-testid={"bol-notations"}>
			<SvgIcon
				className={styles.infoIcon}
				icon={infoCircle}
				themeColor={"primary"}
			/>
			<span className={styles.bolNotationsText}>{notations}</span>
		</div>
	);
};
